/**
 * ageConfig.js — SINGLE SOURCE OF TRUTH for all age ranges & tier
 * labels displayed to parents, teachers and children.
 *
 * Every marketing / help / SEO surface that mentions ages MUST import
 * from here. If you find a hardcoded "5-15" or "5-7" anywhere, replace
 * it with a read from this module.
 *
 * Placement rule (surfaced next to tier labels):
 *   Tiers are shown as an age guideline. Kids can play any tier —
 *   we recommend picking by their reading & maths comfort, not their
 *   age. Content is auto-scaffolded to each tier.
 */

export const OVERALL_RANGE = "4–15";

export const TIERS = [
  { id: "seedlings", label: "Seedlings", range: "4–6"   },
  { id: "explorers", label: "Explorers", range: "7–10"  },
  { id: "pioneers",  label: "Pioneers",  range: "11–15" },
];

/** Human-readable comma list: "Seedlings 4–6, Explorers 7–10, Pioneers 11–15". */
export function tiersInlineLabel() {
  return TIERS.map((t) => `${t.label} ${t.range}`).join(", ");
}

/** Short "4–6 · 7–10 · 11–15" style dot separator used on cards. */
export function tiersDotLabel() {
  return TIERS.map((t) => t.range).join(" · ");
}

/** Look up a tier by id — returns null if unknown. */
export function tierById(id) {
  return TIERS.find((t) => t.id === id) || null;
}

/** Placement guidance shown wherever tiers are explained. */
export const PLACEMENT_NOTE =
  "Tiers are a guideline by age. Kids can play any tier — pick by reading & maths comfort. Content auto-scaffolds to the tier.";
